import {toCommaedNumber as common_toCommaedNumber} from "../common";

export function TimeDataToText(val, _context) {
    return val?.toText() ?? "미납";
}

export function toCommaedNumber(val, _context) {
    return common_toCommaedNumber(val);
}
